// deps
// eslint-disable-next-line import/no-unresolved
import generateUrl from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/generateUri";

// constants
import apiRouter from "../../../constants/routers/api";

/**
 * Retourne l’URI de la route API demandée.
 * @return {string}
 */
export default function generateApiUrl(param0) {
  return generateUrl({
    router: apiRouter,
    ...param0,
  });
}
